export const arrayOfUrl = [
  "films",
  "species",
  "vehicles",
  "starships",
  "homeworld",
  "characters",
  "planets",
  "residents"
];



// WEBPACK FOOTER //
// ./src/assets/utilities/arrayOfUrl.js